const initVideoWithPlaceholder = () => {
    if (document.querySelector(".gg-block-video")) {
        const getId = (url) => {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);

            return match && match[2].length === 11 ? match[2] : null;
        };

        const createPlayer = (url) => {
            const iframe = document.createElement("iframe");
            const videoId = getId(url);
            iframe.classList.add("gg-block-video__content", "gg-block-video__iframe");
            iframe.setAttribute("allow", "autoplay; fullscreen");
            iframe.setAttribute("frameborder", 0);
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0`;
            return iframe;
        };

        document.querySelectorAll(".gg-block-video").forEach((videoContainer) => {
            if (!videoContainer.querySelector(".gg-block-video__image")) {
                const iframe = videoContainer.querySelector(".gg-block-video__iframe");
                const videoId = getId(iframe.getAttribute("data-src"));
                iframe.src = `https://www.youtube.com/embed/${videoId}?mute=0`;
            } else {
                videoContainer.addEventListener("click", (e) => {
                    const iframe = createPlayer(videoContainer.dataset.src);
                    e.stopPropagation();
                    videoContainer.appendChild(iframe);
                    videoContainer.classList.add("gg-block-video__player");
                });
            }
        });
    }
};

initVideoWithPlaceholder();

if (window.acf) {
    window.acf.addAction("render_block_preview/type=video", initVideoWithPlaceholder);
}
